<template lang="pug">
.form-new-rent
  h2 续交租金
  el-form.ui.form(:model='form')
    .three.fields
      el-form-item.ui.field.required(prop='date_start')
        label 开始日期
        datepicker(v-model='form.date_start', placeholder='开始日期', disabled)
      el-form-item.ui.field.required(prop='rent_month')
        label 时长 (月)
        el-input-number(v-model='form.rent_month', :min='0', :max='rent_month_max')
      el-form-item.ui.field.required(prop='date_end')
        label 结束日期
        datepicker(v-model='form.date_end', placeholder='结束日期', :min='form.date_start', :max='date_contract_end')
    .three.fields
      el-form-item.field.required(prop='price_month')
        label 租金 / 月
        el-input-number(v-model='form.price_month', type='number', :controls='false')
      el-form-item.field.required(prop='amount_due')
        label 应付租金
        el-input-number(v-model='form.amount_due', type='number', disabled, :controls='false')
      el-form-item.field.required(prop='amount_paid')
        label 实收租金
        el-input-number(v-model='form.amount_paid', type='number', :controls='false')

    .three.fields
      el-form-item.ui.field.required(prop='management_fee_month')
        label 管理费 / 月
        el-input-number(v-model='form.management_fee_month', :min='0', :controls='false')
      el-form-item.ui.field.required(prop='network_fee_month')
        label 网络费 / 月
        el-input-number(v-model='form.network_fee_month', :min='0', :controls='false')
      el-form-item.field.required(prop='management_fee')
        label 总管理费
        el-input-number(v-model='form.management_fee', type='number', :controls='false')
      el-form-item.field.required(prop='network_fee')
        label 总网络费
        el-input-number(v-model='form.network_fee', type='number', :controls='false')
      el-form-item.field(prop='payment_method')
        label 支付方式
        payment-method-select(v-model='form.payment_method')

    el-form-item.ui.field(prop='note')
      label 备注
      textarea(v-model='form.note', rows='2')

    .ui.field
      receipts(v-show='receipts && receipts.length', :receipts='receipts')

    .ui.field
      .ui.button.themed(@click='submit') 确认缴交
      .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { Datepicker, Receipts, PaymentMethodSelect } from '../basic'

export default {
  name: 'form-new-rent',
  props: ['contract_id', 'no'],
  components: { Datepicker, PaymentMethodSelect, Receipts },
  data() {
    return {
      form: {
        _room: null,
        _contract: null,
        date_start: null,
        date_end: null,
        rent_month: 2,
        rent_day: 0,
        price_month: 1000,
        amount_paid: 0,
        amount_due: 0,
        management_fee: 0,
        network_fee: 0,
        management_fee_month: 0,
        network_fee_month: 0,
        payment_method: 'cash',
        note: '',
        state: 'paid',
      },
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    contract_id() {
      this.init()
    },
    'form.rent_month': function () {
      this.update_date()
      this.update_price()
      this.form.rent_day = 0
    },
    'form.rent_day': function () {
      this.update_date()
    },
    'form.price_month': function () {
      this.update_price()
    },
    'form.management_fee_month': function () {
      this.update_price()
    },
    'form.network_fee_month': function () {
      this.update_price()
    },
  },
  computed: {
    contract() {
      return this.$store.getters.contract(this.contract_id)
    },
    date_start() {
      if (this.form.date_start)
        return this.$moment(this.form.date_start)
    },
    date_contract_expired() {
      if (this.contract && (this.contract.date_expire || this.contract.date_start))
        return this.$moment(this.contract.date_expire || this.contract.date_start)
    },
    date_contract_end() {
      if (this.contract && this.contract.date_end)
        return this.$moment(this.contract.date_end)
    },
    rent_month_max() {
      if (this.date_contract_end && this.date_contract_expired)
        return this.$moment.monthsBetween(this.date_contract_end, this.date_contract_expired)
      return 36
    },
    rent_day_max() {
      if (this.date_contract_end && this.date_start && this.form.rent_month === this.rent_month_max)
        return this.$moment.daysBetween(this.date_contract_end, this.date_start.add(this.form.rent_month, 'month'))
      return 31
    },
    receipts() {
      return [
        {
          name: '租金',
          unit: '个月',
          unit_price: this.form.price_month,
          quantity: this.form.rent_month,
          money: this.form.amount_paid,
        },
        {
          name: '管理费',
          unit: '个月',
          unit_price: this.form.management_fee_month,
          quantity: this.form.rent_month,
        },
        {
          name: '网络费',
          unit: '个月',
          unit_price: this.form.network_fee_month,
          quantity: this.form.rent_month,
        },
      ]
    },
  },
  methods: {
    init() {
      this.form._room = this.contract._room
      this.form._contract = this.contract_id
      this.form.date_start = this.$moment(this.contract.date_expire || this.contract.date_start).startOf('days').add(1, 'days')
      this.form.rent_month = this.contract.pay_unit_month
      this.form.price_month = this.contract.price_month || this.form.price_month
      this.form.management_fee_month = this.contract.management_fee_month
      this.form.network_fee_month = this.contract.network_fee_month
      this.update_date()
      this.update_price()
    },
    update_date() {
      this.form.date_end = this.$moment(this.form.date_start)
        .add(this.form.rent_month, 'months')
        .add(this.form.rent_day, 'days')
        .subtract(this.form.rent_month ? 1 : 0, 'days')
        .toDate()
    },
    update_price() {
      this.form.management_fee = this.form.management_fee_month * this.form.rent_month
      this.form.network_fee = this.form.network_fee_month * this.form.rent_month
      this.form.amount_due = this.form.rent_month * this.form.price_month
      this.form.amount_paid = this.form.amount_due
    },
    print_fee() {
      const quantity = `${this.form.rent_month}个月`
      const note = `${this.$formatters.date.to_date(this.form.date_start)} - ${this.$formatters.date.to_date(this.form.date_end)}`
      const room = this.no
      const payment_method = this.$formatters.payment_method(this.form.payment_method, this.$store.state.summary.payment_methods) || undefined
      this.$templater.request('other_fee', {
        room_no: this.no,
        fees: [
          {
            room,
            subject: '租金',
            note,
            quantity,
            payment_method,
            money: this.form.price_month * this.form.rent_month,
          },
          {
            room,
            subject: '管理费',
            note,
            quantity,
            payment_method,
            money: this.form.management_fee_month * this.form.rent_month,
          },
          {
            room,
            subject: '网络费',
            note,
            quantity,
            payment_method,
            money: this.form.network_fee_month * this.form.rent_month,
          },
        ],
      })
    },
    cancel() {
      this.$router.back()
    },
    submit_form: MakeForm({
      type: 'post',
      url: 'rents/new',
      confirm: '确认缴交租金？',
      payload() {
        return this.form
      },
      $afterSuccess() {
        this.print_fee()
        this.$router.$go.room({ no: this.no })
      },
    }),
    submit() {
      this.submit_form()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormNewRent.vue?44753e3f